import { render, staticRenderFns } from "./PCBConverter.vue?vue&type=template&id=3b92905d&scoped=true&"
import script from "./PCBConverter.vue?vue&type=script&lang=js&"
export * from "./PCBConverter.vue?vue&type=script&lang=js&"
import style0 from "./PCBConverter.vue?vue&type=style&index=0&id=3b92905d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b92905d",
  null
  
)

export default component.exports